import Service from '../../balancer-subgraph.service';
import queryBuilder from './query';
import { BalancersType, QueryBuilder } from '../../types';

export default class Balancers {
  service: Service;
  query: QueryBuilder;

  constructor(service: Service, query: QueryBuilder = queryBuilder) {
    this.service = service;
    this.query = query;
  }

  public async get(args = {}, attrs = {}): Promise<BalancersType[]> {
    const query = this.query(args, attrs);
    const data = await this.service.client.get(query);
    return data.balancers;
  }
}
